import admin from "@/assets/admin.jpg";
import LogoutAlert from "@/components/logout-alert/LogoutAlert";
import useGetApiReq from "@/hooks/useGetApiReq";
import { openCloseSideBar } from "@/store/slices/sidebarSlice";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { MdClose, MdLogout, MdMenu } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

import { readCookie } from "@/utils/readCookie";
import NotificationComp from "../notification-comp/NotificationComp";


const Header = () => {
  const { res, fetchData } = useGetApiReq();

  const [logoutAlertModalOpen, setLogoutAlertModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isOpen } = useSelector((state) => state.sidebar);
  const { user } = useSelector((state) => state.user);
  const userCookie = readCookie("user");
  const permissions = userCookie?.permissions;


  const handleLogout = async () => {
    fetchData("/admin/logout");
  };

  useEffect(() => {
    if (res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message);
      navigate("/admin/login");
    }
  }, [res]);

  const handleOpen = () => {
    dispatch(openCloseSideBar());
  };


  return (
    <>
      <div className="flex h-[96px] justify-between items-center p-4 px-10 glass-header text-black z-20 sticky top-0">
        {/* <div className="w-16 h-16 cursor-pointer" onClick={() => navigate("/admin/dashboard")}>
          <img src={logo} alt="logo" className="w-full h-full" />
        </div> */}
        <h1 className="text-2xl font-bold">Superloopz</h1>

        <div className="flex gap-3 items-center">
          <div className="flex items-center gap-2 mr-4">
            <Avatar>
              <AvatarImage src={admin} />
              <AvatarFallback>Admin</AvatarFallback>
            </Avatar>
            Hello, {user?.name}
          </div>

          {permissions?.clients !== "none" && permissions?.chats !== "none" && (
            <NotificationComp />
          )}

          {isOpen ? (
            <MdClose
              onClick={handleOpen}
              size={25}
              className="min-[1000px]:hidden h-[100vh-100px] ml-4 cursor-pointer"
            />
          ) : (
            <MdMenu
              onClick={handleOpen}
              size={25}
              className="min-[1000px]:hidden h-[100vh-100px] ml-4 cursor-pointer"
            />
          )}

          <MdLogout
            size={25}
            cursor={"pointer"}
            onClick={() => setLogoutAlertModalOpen(true)}
          />
        </div>
      </div>
      <LogoutAlert
        setLogoutAlertModalOpen={setLogoutAlertModalOpen}
        logoutAlertModalOpen={logoutAlertModalOpen}
        handleLogout={handleLogout}
      />
    </>
  );
};

export default Header;